import { useState } from "react";
import { Button, message, Popconfirm, Tooltip } from "antd";
import { SearchOutlined } from "@ant-design/icons";

const Auth0UserBlockControl = ({
  user,
  checking,
  unlocking,
  onCheck,
  onUnblock,
}) => {
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleCheck = async () => {
    try {
      const result = await onCheck(user.objectId);
      if (result.blocked) {
        setConfirmOpen(true);
      } else {
        message.success(
          "L'utente non risulta bloccato per troppi tentativi su Auth0"
        );
      }
    } catch (error) {
      message.error(
        error.message || "Impossibile verificare l'utente su Auth0"
      );
    }
  };

  const handleUnblock = async () => {
    try {
      const result = await onUnblock(user.objectId);
      if (result.verificationFailed) {
        message.warning(
          "Richiesta di sblocco inviata, ma lo stato finale non è verificabile"
        );
      } else {
        message.success(
          result.alreadyClear
            ? "L'utente non risulta bloccato per troppi tentativi su Auth0"
            : "Utente sbloccato su Auth0"
        );
      }
    } catch (error) {
      message.error(error.message || "Impossibile sbloccare l'utente su Auth0");
    } finally {
      setConfirmOpen(false);
    }
  };

  return (
    <Tooltip
      title="Controlla se Auth0 ha bloccato l'utente per troppi tentativi di accesso."
    >
      <Popconfirm
        title="Utente bloccato su Auth0"
        description="Vuoi rimuovere i blocchi dovuti ai tentativi di accesso falliti?"
        open={confirmOpen}
        onOpenChange={(nextOpen) => {
          if (!nextOpen) setConfirmOpen(false);
        }}
        okText="Sblocca"
        cancelText="Annulla"
        okButtonProps={{ danger: true, loading: unlocking }}
        onConfirm={handleUnblock}
        onCancel={() => setConfirmOpen(false)}
      >
        <Button
          size="small"
          icon={<SearchOutlined />}
          loading={checking}
          onClick={handleCheck}
        >
          Verifica
        </Button>
      </Popconfirm>
    </Tooltip>
  );
};

export default Auth0UserBlockControl;
